'use client';

import { Elements } from '@prezly/content-renderer-react-js';
import type { AttachmentNode } from '@prezly/story-content-format';

import { StoryFile } from '@/lib/tracking';
import { segment } from '@/lib/tracking/segmentAnalytics';

interface Props {
    node: AttachmentNode;
}

export function Attachment({ node }: Props) {
    function handleClick() {
        segment.track(StoryFile.DOWNLOAD, { id: node.file.uuid });
    }

    return <Elements.Attachment node={node} onClick={handleClick} />;
}
